import { render, staticRenderFns } from "./VirtualAccountKLNetPop.vue?vue&type=template&id=1476e7ac&scoped=true"
import script from "./VirtualAccountKLNetPop.vue?vue&type=script&lang=js"
export * from "./VirtualAccountKLNetPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1476e7ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1476e7ac')) {
      api.createRecord('1476e7ac', component.options)
    } else {
      api.reload('1476e7ac', component.options)
    }
    module.hot.accept("./VirtualAccountKLNetPop.vue?vue&type=template&id=1476e7ac&scoped=true", function () {
      api.rerender('1476e7ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settle/popup/VirtualAccountKLNetPop.vue"
export default component.exports